import ElementManager from "./ElementManager";

function register(moduleElements) {
    if (moduleElements == undefined) {
        throw new Error("module not initialized, possible circular dependency?");
    }
    for (const className in moduleElements) {
        // elements[className] = moduleElements[className];
        ElementManager._register(className, moduleElements[className]);
    }
}

//
// only primary elements need to be registered here
//

import * as Decoration from "./base/DecorationElement";
register(Decoration.elements);

import * as Header from "./elements/Header";
register(Header.elements);

import * as Authoring from "./elements/AuthoringCanvas";
register(Authoring.elements);

import * as Countdown from "./elements/Countdown";
register(Countdown.elements);

import * as Timer from "./elements/Timer";
register(Timer.elements);

import * as Agenda from "./elements/Agenda";
register(Agenda.elements);

import * as BigNumbers from "./elements/BigNumbers";
register(BigNumbers.elements);

import * as WebView from "./elements/WebView";
register(WebView.elements);

import * as Calendar from "./elements/Calendar";
register(Calendar.elements);

import * as VerticalTaskList from "./elements/VerticalTaskList";
register(VerticalTaskList.elements);

import * as HorizontalTaskList from "./elements/HorizontalTaskList";
register(HorizontalTaskList.elements);

import * as ArrowBars from "./elements/ArrowBars";
register(ArrowBars.elements);

import * as RadialBarChart from "./elements/RadialBarChart";
register(RadialBarChart.elements);

import * as Target from "./elements/Target";
register(Target.elements);

import * as SimpleGanttChart from "./elements/GanttChart";
register(SimpleGanttChart.elements);

import * as Compare from "./elements/compare";
register(Compare.elements);

import * as ContactInfo from "./elements/ContactInfo";
register(ContactInfo.elements);

import * as Dashboard from "./elements/Dashboard";
register(Dashboard.elements);

import * as DebugBox from "./elements/DebugBox";
register(DebugBox.elements);

import * as Embed from "./elements/Embed";
register(Embed.elements);

import * as Headline from "./elements/Headline";
register(Headline.elements);

import * as HubAndSpoke from "js/elements/elements/Diagrams/HubAndSpoke";
register(HubAndSpoke.elements);

import * as IconCircle from "js/elements/elements/Diagrams/IconCircle";
register(IconCircle.elements);

import * as Journey from "./elements/Journey";
register(Journey.elements);

import * as NodeDiagram from "./elements/NodeDiagram";
register(NodeDiagram.elements);

import * as LogoGrid from "./elements/LogoGrid";
register(LogoGrid.elements);

import * as OrgChart from "./elements/OrgChart";
register(OrgChart.elements);

import * as PhotoCollage from "./elements/PhotoCollage";
register(PhotoCollage.elements);

import * as PhotoTextList from "js/elements/elements/Lists/PhotoTextList";
register(PhotoTextList.elements);

import * as PictorialCharts from "./elements/PictorialChart";
register(PictorialCharts.elements);

import * as PresentationTitle from "./elements/PresentationTitle";
register(PresentationTitle.elements);

import * as ProcessDiagram from "./elements/ProcessDiagram";
register(ProcessDiagram.elements);

import * as ProductScreenshot from "./elements/ProductScreenshot";
register(ProductScreenshot.elements);

import * as Pyramid from "./elements/Pyramid";
register(Pyramid.elements);

import * as SliceChart from "./elements/SliceChart";
register(SliceChart.elements);

import * as SlidePlaceholder from "./elements/SlidePlaceholder";
register(SlidePlaceholder.elements);

import * as StackDiagram from "./elements/StackDiagram";
register(StackDiagram.elements);

import * as SwotDiagram from "./elements/SwotDiagram";
register(SwotDiagram.elements);

import * as Table from "js/elements/elements/Table/Table";
register(Table.elements);

import * as TableV1 from "js/elements/elements/Table/previous/Table.v1";
register(TableV1.elements);

import * as Team from "./elements/Team";
register(Team.elements);

import * as TextBoxGrid from "./elements/TextBoxGrid";
register(TextBoxGrid.elements);

import * as TextGrid from "js/elements/elements/Lists/previous/TextGrid";
register(TextGrid.elements);

import * as TextList from "js/elements/elements/Lists/TextList";
register(TextList.elements);

import * as IconsList from "js/elements/elements/Lists/IconsList";
register(IconsList.elements);

import * as Carousel from "js/elements/elements/Lists/Carousel";
register(Carousel.elements);

import * as TextSlide from "./elements/TextSlide";
register(TextSlide.elements);

import * as Timeline from "./elements/Timeline";
register(Timeline.elements);

import * as UserTestimonial from "./elements/UserTestimonial";
register(UserTestimonial.elements);

import * as VennDiagram from "./elements/VennDiagram";
register(VennDiagram.elements);

import * as Video from "./elements/Video";
register(Video.elements);

import * as WordCloudElement from "./elements/WordCloud";
register(WordCloudElement.elements);

import * as XYGraph from "js/elements/elements/Diagrams/XYGraph";
register(XYGraph.elements);

import * as Thermometer from "./elements/Thermometer";
register(Thermometer.elements);

import * as PPTSlide from "./elements/PPTSlide";
register(PPTSlide.elements);
